import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import DeleteIcon from "./../../Images/black-x.png";
import { useTrialAuth } from "../../Context/TrialAuthContext";
import { useDispatch } from "react-redux";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";

const CardTrial = ({ data, setHeadingFocused }) => {
  const { editLocalData, editLocalNumberData, deleteLocalData } =
    useTrialAuth();
  const [cardFocused, setCardFocused] = useState(false);
  const currentPage = "Fastakostnader";

  const dispatch = useDispatch();

  function handleEdit(e, id) {
    //regex allow only numbers and decimals
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    if (e.target.name.includes("amount")) {
      if (e.target.value.match(regex)) {
        editLocalNumberData(e, id);
      }
      //if input is "" editLocalNumberData returns 0
      else if (e.target.value === "") {
        editLocalNumberData(e, id);
        handleZero(e);
      } else {
        //stop not allowed
        e.target.value = e.target.value.replace(/[^/\d\d{1,2}]/g, "");
        dispatch(
          getErrorMessage(
            `Felaktig inmatning i ${currentPage}, var god skriv in siffror!`
          )
        );
        const delayEditData = setTimeout(() => {
          dispatch(getErrorMessage(""));
        }, 5000);
        return () => clearTimeout(delayEditData);
      }
    } else {
      editLocalData(e, id);
    }
  }
  //if input is 0 select/highlight 0
  function handleZero(e) {
    if (e.target.value === "0") {
      e.target.select();
    }
  }
  function handleDelete(id) {
    deleteLocalData(id);
  }

  return (
    <Row
      className={`
        g-0 mt-2 rounded-3 
        ${cardFocused ? "cards-focused" : "cards"} 
      `}
      onFocus={() => setCardFocused(true)}
      onBlur={() => setCardFocused(false)}
    >
      <Col xs={22} className="offset-2 p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center 
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="category"
          defaultValue={data.object.category}
          autoComplete="off"
          maxLength="30"
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        />
      </Col>

      <Col xs={8} className="offset-1 p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
              form-control text-center 
              ${cardFocused ? "input-element-focused" : "input-element"}
            `}
          name="amount"
          defaultValue={data.object.amount === "0" ? "" : data.object.amount}
          autoComplete="off"
          maxLength="7"
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
          onClick={(e) => handleZero(e)}
        />
      </Col>

      <Col
        xs={3}
        className={` 
          offset-4 pe-2 d-flex align-items-center
          ${cardFocused ? "cards-delete-button-focused" : "cards-delete-button"}
        `}
        onClick={() => handleDelete(data.id)}
      >
        <img
          src={DeleteIcon}
          alt="Delete icon"
          className="img-fluid max-width:100% height:auto mx-auto d-block w-50 x-button"
        />
      </Col>
    </Row>
  );
};
export default CardTrial;
